namespace Matrix.Membership {
    export interface LoginResponse extends Serenity.ServiceResponse {
        RedirectUrl?: string;
    }
}
